<template>
  <div class="acomodar">
    <div class="container-fluid py-3 px-2 px-md-4">
    
      <form @submit.prevent="RegistrarSolcitud">

        <!-- TÍTULO -->
        <div class="border border-1 rounded-3 p-3 mb-3 ">
          <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
            <i class="bi bi-card-text display-4 text-primary"></i>
            <div>
              <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
                REGISTRO DE SOLICITUD
              </p>
              <p class="mb-0 tituloResaltado fs-4 fw-bold">
                DATOS DE REQUERIMIENTO (RQ)
              </p>
            </div>
          </div>
        </div>

        <!-- BOTÓN GUARDAR -->
        <div class="mb-3">
          <button type="submit" :disabled="isdisabled" class="btn btn-success">
            <i class="bi bi-floppy"></i>
          </button>
        </div>

        <!-- SOLICITADO POR -->
        <div class="border border-1 rounded-3 p-3 mb-3 bg-light">
          <div class="row align-items-center">
            <div class="col-md-9 col-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-person-vcard text-primary fs-5"></i>
                REQUERIMIENTO SOLICITADO POR:
              </label>
              <strong class="text-dark ms-4">
                {{ NombresUsers }} - {{ Cargos }}
              </strong>
            </div>

            <div class="col-md-3 col-12 d-flex align-items-center justify-content-md-end mt-3 mt-md-0">
              <input v-model="form.campana" type="checkbox" class="form-check-input me-2">
              <label class="tamaño mb-0 fw-bold text-danger d-flex align-items-center gap-1">
                <i class="bi bi-bullseye fs-6"></i>
                CAMPAÑA
              </label>
            </div>
          </div>
        </div>


        <!-- PUESTO Y DETALLES -->
        <div class=" border border-1 rounded-3 p-3 mb-3 bg-light">
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-6 col-12 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-briefcase-fill text-primary fs-6"></i> PUESTO SOLICITADO:
              </label>
              <select v-model="seleccionarPuesto" @change="Puesto($event)"
                class="form-select form-select-sm text-secondary" required>
                <option disabled value="">-- SELECCIONAR PUESTO --</option>
                <option v-for="puesto in puestos" :key="puesto.id" :value="puesto.idPuesto">
                  {{ puesto.ptoNombre }}
                </option>
              </select>
            </div>

            <div class="col-lg-1 col-md-3 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-123 text-primary fs-6"></i> CANTIDAD:
              </label>
              <input v-model="form.canPostulante" type="number" class="form-control form-control-sm" required />
            </div>

            <div class="col-lg-2 col-md-3 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-calendar-event text-primary fs-6"></i> FECHA REQUERIDA:
              </label>
              <input v-model="form.fecSolicitada" type="date" class="form-control form-control-sm" :min="fechaDeAhora"
                required />
            </div>

            <div class="col-lg-4 col-md-6 col-12 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-chat-left-text text-primary fs-6"></i> DETALLE ADICIONAL:
              </label>
              <input v-model="form.desMotivo" type="text" class="form-control form-control-sm" required
                @input="form.desMotivo = form.desMotivo.replace(/^\s+/, '')" />
            </div>

            <div class="col-lg-2 col-md-6 col-12 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-exclamation-diamond text-primary fs-6"></i> MOTIVO SOLICITUD:
              </label>
              <select v-model="motivoSol" @change="Motivo($event)" class="form-select form-select-sm text-secondary"
                required>
                <option disabled value="">-- SELECCIONAR --</option>
                <option v-for="motivo in motivoSolicitud" :key="motivo.id" :value="motivo.parCorrelativo">
                  {{ motivo.parDescripcion }}
                </option>
              </select>
            </div>

            <!-- Descripción -->
            <div class="col-12 mt-3">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-chat-left-text text-primary fs-6"></i> DESCRIPCIÓN DEL PUESTO:
              </label>
              <textarea v-model="form.desExtra" rows="3" class="form-control form-control-sm" required
                @input="form.desExtra = form.desExtra.replace(/^\s+/, '')"></textarea>
            </div>
          </div>
        </div>

        <!-- UBICACIÓN Y EMPRESA -->
        <div class=" border border-1 rounded-3 p-3 mb-3 bg-light">
          <div class="row align-items-center">

            <div class="col-lg-3 col-md-6 col-12 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-building text-primary fs-6"></i> EMPRESA:
              </label>
              <select v-model="empresaDes" @change="Empresa($event)" class="form-select form-select-sm text-secondary"
                required>
                <option disabled value="">-- SELECCIONAR EMPRESA --</option>
                <option v-for="empresas in DniEmpre" :key="empresas.id" :value="empresas.id">
                  {{ empresas.empRazSocial }}
                </option>
              </select>
            </div>

            <!-- CENTRO DE COSTOS -->
            <!-- v-if="permisoVisualizador != 8" -->
            <div v-if="CentroCosto.length > 1" class="col-lg-3 col-md-6 col-12 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-coin text-primary fs-6"></i> CENTRO DE COSTOS:
              </label>

              <!-- v-model="costos" @change="CostosEvent($event)"-->
              <select v-if="CentroCosto.length == 1" disabled class="form-select form-select-sm text-secondary"
                required>

                <option v-if="!CentroCosto.length || !CentroCosto[0].cenNombre" selected value="">
                  -- SELECCIONAR --
                </option>
                <option v-else value="">
                  {{ CentroCosto[0].cenNombre }}
                </option>
                <!-- <option disabled value="">-- SELECCIONAR --</option> -->
                <!-- <option disabled value="">{{ CentroCosto[0].cenNombre ? '' : '' }}</option> 

              <option v-for="CentroCostos in CentroCosto" :key="CentroCostos.id" :value="CentroCostos.cenCodigo">
                {{ CentroCostos.cenNombre }}
              </option> -->
              </select>


              <select v-else v-model="costos" @change="cenCodigoCentro = $event.target.value, CostosEvent()"
                class="form-select form-select-sm text-secondary" required>


                <option disabled selected value="">-- SELECCIONAR --</option>

                <option v-for="CentroCostos in CentroCosto" :key="CentroCostos.id" :value="CentroCostos.cenCodigo">
                  {{ CentroCostos.cenNombre }}
                </option>
              </select>
            </div>

            <!-- SUB CENTRO -->
            <div class="col-lg-3 col-md-6 col-12 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-diagram-2 text-primary fs-6"></i> PROYECTO:
              </label>
              <select v-model="subCostos" @change="SubCostros($event)" class="form-select form-select-sm text-secondary"
                required>
                <option disabled selected value="">-- SELECCIONAR --</option>
                <option v-for="SubCentroCostos in SubCentroCosto" :key="SubCentroCostos.id" :value="SubCentroCostos">
                  {{ SubCentroCostos.cenNombre }}
                </option>
              </select>
            </div>

            <!-- SUB SUB CENTRO -->
            <div class="col-lg-3 col-md-6 col-12 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-diagram-2-fill text-primary fs-6"></i> CANAL:
              </label>
              <select v-model="subSubCentroCostos" @change="SubSubCentroCostoId($event)"
                class="form-select form-select-sm text-secondary" required>
                <option disabled value="">-- SELECCIONAR --</option>
                <option v-for="SubSubCentroCostos in SubSubCentroCosto" :key="SubSubCentroCostos.id"
                  :value="SubSubCentroCostos.id">
                  {{ SubSubCentroCostos.cenNombre }}
                </option>
              </select>
            </div>

            <div v-if="aparecerReniel" class="col-lg-12 col-md-12 col-lg-12 mt-2">
              <label class="tamaño d-flex align-items-center gap-2"> <i
                  class="bi bi-three-dots text-primary fs-6"></i>RENEEIL:</label>
              <select v-model="reneeil" required @change="ServicioComplemetarios($event)"
                class="form-select form-select-sm text-secondary">
                <option disabled value="">-- SELECCIONAR RENEEIL --</option>
                <option v-for="ren in reneeils" :key="ren.id" :value="ren.parCorrelativo">
                  {{ ren.parDescripcion }}
                </option>
              </select>
            </div>

            <!-- GERENCIA -->
            <div class="col-lg-3 col-md-6 col-12 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-diagram-3 text-primary fs-6"></i> GERENCIA:
              </label>
              <select v-model="gerenciaDes" @focus="validaciongerencia" @change="Gerencia($event)"
                class="form-select form-select-sm text-secondary" required>
                <option disabled value="">-- SELECCIONAR --</option>
                <option v-for="gerencias in gerencia" :key="gerencias.id" :value="gerencias.parCorrelativo">
                  {{ gerencias.parDescripcion }}
                </option>
              </select>
            </div>



            <!-- DEPARTAMENTO -->
            <div class="col-lg-3 col-md-6 col-12 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-building-gear text-primary fs-6"></i> DEPARTAMENTO:
              </label>
              <select v-model="departamentoDes" @change="Depa($event)" class="form-select form-select-sm text-secondary"
                required>
                <option disabled value="">-- SELECCIONAR --</option>
                <option v-for="departamentos in departamento" :key="departamentos.id"
                  :value="departamentos.idParametro">
                  {{ departamentos.parDescripcion }}
                </option>
              </select>
            </div>

            <!-- PROVINCIA -->
            <div class="col-lg-3 col-md-6 col-12 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-geo-alt text-primary fs-6"></i> PROVINCIA:
              </label>
              <select v-model="provinciasDes" @change="Province($event)"
                class="form-select form-select-sm text-secondary" required>
                <option disabled value="">-- SELECCIONAR --</option>
                <option v-for="provincia in provincias" :key="provincia.id" :value="provincia.idParametro">
                  {{ provincia.parDescripcion }}
                </option>
              </select>
            </div>

            <!-- DISTRITO -->
            <div v-if="regiones != 1733" class="col-lg-3 col-md-6 col-12 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-geo text-primary fs-6"></i> DISTRITO:
              </label>
              <select v-model="distritoDes" @change="DistritoDes($event)"
                class="form-select form-select-sm text-secondary" required>
                <option disabled value="">-- SELECCIONAR --</option>
                <option v-for="distritos in distrito" :key="distritos.id" :value="distritos.parCorrelativo">
                  {{ distritos.parDescripcion }}
                </option>
              </select>
            </div>


            <div v-else class="col-lg-3 col-md-6 col-12 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-geo text-primary fs-6"></i> ZONA:
              </label>
              <select :disabled="regiones != 1733" @change="DistritoDes($event)"
                class="form-select form-select-sm text-secondary" required>
                <option disabled selected value="">-- SELECCIONAR --</option>
                <option v-for="region in subRegiones" :key="region.id" :value="region.parCorrelativo">
                  {{ region.parDescripcion }}
                </option>
              </select>
            </div>


            <!-- TIPO DE CONTRATO -->
            <!-- <div class="col-lg-3 col-md-6 col-12 mt-2">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-file-text text-primary fs-6"></i> TIPO DE CONTRATO:
            </label>
            <select v-model="contratoDes" @focus="cargarContratos" @change="TipContratato($event)"
              class="form-select form-select-sm text-secondary" required>
              <option disabled value="">-- SELECCIONAR CONTRATO --</option>
              <option v-for="contrato in contratos" :key="contrato.id" :value="contrato.parCorrelativo">
                {{ contrato.parDescripcion }}
              </option>
            </select>
          </div> -->

            <!-- CATEGORIA OCUPACIONAL -->
            <!-- <div class="col-lg-6 col-md-6 col-12 mt-2">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-person-gear text-primary fs-6"></i> CATEGORÍA OCUPACIONAL:
            </label>

            <select disabled v-model="categoria" @change="CategoriaOcupa($event)"
              class="form-select form-select-sm text-secondary" required>
              <option disabled value="">EMPLEADO</option>
              <option v-for="ocupo in ocupacional" :key="ocupo.id" :value="ocupo.parCorrelativo">
                {{ ocupo.parDescripcion }}
              </option>
            </select>
          </div> -->

            <!-- PLAZO -->
            <div class="col-lg-1 col-md-2 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-hourglass-split text-primary fs-6"></i> PLAZO:
              </label>
              <input v-model="form.plazo" type="number" class="form-control form-control-sm" required>
            </div>

            <!-- TIEMPO -->
            <div class="col-lg-2 col-md-2 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-clock text-primary fs-6"></i> TIEMPO:
              </label>
              <select v-model="tiempoDes" @change="Tiempo($event)" class="form-select form-select-sm text-secondary"
                required>
                <option disabled value="">-- SELECCIONAR --</option>
                <option v-for="tiempo in tiempos" :key="tiempo.id" :value="tiempo.parCorrelativo">
                  {{ tiempo.parDescripcion }}
                </option>
              </select>
            </div>

            <!-- INICIO CONTRATO -->
            <div class="col-lg-2 col-md-2 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-calendar-check text-primary fs-6"></i> INICIO CONTRATO:
              </label>
              <input v-model="form.fecIniContrato" type="date" class="form-control form-control-sm text-secondary"
                :min="fechaDeAhora" required>
            </div>

            <!-- FIN CONTRATO -->
            <div class="col-lg-2 col-md-2 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-calendar-x text-primary fs-6"></i> FIN CONTRATO:
              </label>
              <input v-model="form.fecFinContrato" type="date" class="form-control form-control-sm text-secondary"
                :min="fechaDeAhora" required>
            </div>

            <!-- LUGAR TRABAJO -->
            <div class="col-lg-2 col-md-2 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-geo-alt-fill text-primary fs-6"></i> LUGAR DE TRABAJO:
              </label>
              <input v-model="form.lugarTrabajo" type="text" class="form-control form-control-sm" required
                @input="form.lugarTrabajo = form.lugarTrabajo.replace(/^\s+/, '')" />
            </div>

            <!-- HORA TRABAJO -->
            <div class="col-lg-3 col-md-6 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-alarm text-primary fs-6"></i> HORA DE TRABAJO:
              </label>
              <input v-model="form.horTrabajo" type="text" class="form-control form-control-sm" required
                @input="form.horTrabajo = form.horTrabajo.replace(/^\s+/, '')" />
            </div>

            <!-- OPORTUNIDAD DE PAGO -->
            <!-- <div class="col-lg-3 col-md-6 col-12 mt-2">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-wallet2 text-primary fs-6"></i> OPORTUNIDAD DE PAGO:
            </label>

            <select disabled v-model="pagoDes" @change="OportunidadPago($event)"
              class="form-select form-select-sm text-secondary" required>
              <option disabled value="">MENSUAL</option>
              <option v-for="oportunidad in oportunidad" :key="oportunidad.id" :value="oportunidad.parCorrelativo">
                {{ oportunidad.parDescripcion }}
              </option>
            </select>
          </div> -->

            <!-- DIAS DESCANSO -->
            <div class="col-lg-2 col-md-3 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-calendar2-week text-primary fs-6"></i> DIAS DE DESCANSO:
              </label>
              <input v-model="form.diasDescanso" type="number" class="form-control form-control-sm" required>
            </div>

            <!-- MONEDA -->
            <div class="col-lg-3 col-md-3 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-currency-exchange text-primary fs-6"></i> MONEDA:
              </label>
              <select v-model="monedas" @change="Moneda($event)" class="form-select form-select-sm text-secondary"
                required>
                <option disabled value="">-- SELECCIONAR MONEDA --</option>
                <option v-for="moneda in monedita" :key="moneda.id" :value="moneda.parCorrelativo">
                  {{ moneda.parDescripcion }}
                </option>
              </select>
            </div>

            <!-- SUELDO MENSUAL -->
            <div class="col-lg-2 col-md-3 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-cash fs-6 text-primary"></i>
                SUELDO MENSUAL
              </label>

              <input v-model.number="form.sueldoMensual" type="number" class="form-control form-control-sm"
                :class="{ 'border-danger': errorSueldoMensual }" @blur="validarSueldoMensual"
                :disabled="form.sueldoDiario > 0" />

              <!-- MENSAJE DE ERROR ABAJO -->
              <div v-if="errorSueldoMensual" class="text-danger mt-1 d-flex align-items-center gap-1 small fw-semibold">
                <i class="bi bi-exclamation-circle-fill"></i>
                (Debe ser ≥ S/ 565)
              </div>
            </div>
            <!-- SUELDO DIARIO -->
            <div class="col-lg-2 col-md-2 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-cash-coin text-primary fs-6"></i> SUELDO DIARIO:
              </label>

              <input v-model.number="form.sueldoDiario" type="number" class="form-control form-control-sm" step="0.01"
                :class="{ 'border-danger': errorSueldoDiario }" @blur="validarSueldoDiario"
                :disabled="form.sueldoMensual > 0" />

              <!-- MENSAJE DE ERROR ABAJO -->
              <div v-if="errorSueldoDiario" class="text-danger mt-1 d-flex align-items-center gap-1 small fw-semibold">
                <i class="bi bi-exclamation-circle-fill"></i>
                ( Debe ser S/ 37.70 y S/ 400)
              </div>
            </div>



            <!-- VARIABLE -->
            <div class="col-lg-1 col-md-2 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-percent text-primary fs-6"></i> VARIABLE:
              </label>
              <input v-model="form.monVariable" type="number" class="form-control form-control-sm">
            </div>

            <!-- ALIMENTACION -->
            <div class="col-lg-1 col-md-2 col-3 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-cup-hot text-primary fs-6"></i> ALIMENTACIÓN:
              </label>
              <input v-model="form.monAlimentacion" type="number" class="form-control form-control-sm">
            </div>

            <!-- MOVILIDAD -->
            <div class="col-lg-1 col-md-2 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-bus-front text-primary fs-6"></i> MOVILIDAD:
              </label>
              <input v-model="form.monMovilidad" type="number" class="form-control form-control-sm">
            </div>

            <!-- HORAS EXTRA -->
            <div class="col-lg-1 col-md-2 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-stopwatch text-primary fs-6"></i> H. EXTRA:
              </label>
              <input v-model="form.horaExtra" type="text" class="form-control form-control-sm">
            </div>

            <!-- VIATICOS -->
            <div class="col-lg-1 col-md-2 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-geo-fill text-primary fs-6"></i> VIÁTICOS:
              </label>
              <input v-model="form.monViatico" type="number" class="form-control form-control-sm">
            </div>

            <!-- OTROS -->
            <div class="col-lg-1 col-md-2 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-three-dots text-primary fs-6"></i> OTROS:
              </label>
              <input v-model="form.monOtro" type="number" class="form-control form-control-sm">
            </div>

            <!-- Checkboxes -->
            <div class="col-lg-1 col-md-2 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-airplane text-primary fs-6"> </i>DISPONIBILIDAD DE VIAJE
              </label>
              <input type="checkbox" class="form-check-input" id="checkEmpo" v-model="form.solDisViaje" />
            </div>

            <div class="col-lg-2 col-md-2 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-phone-landscape text-primary fs-6"> </i> USO DE MOVIL PROPIO CON PAGO DE DATOS
              </label>
              <input type="checkbox" class="form-check-input ms-3" id="checkEmpo" v-model="form.solMovPropio" />
            </div>
            <div class="col-lg-1 col-md-4 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-house-check text-primary fs-6"> </i> USO DE APLICATIVOS
              </label>
              <input type="checkbox" class="form-check-input ms-3" id="checkEmpo" v-model="form.usoSolAplicativo" />
            </div>

            <div class="col-lg-1 col-md-4 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-house-check text-primary fs-6"> </i> USO DE EPPs
              </label>
              <input type="checkbox" class="form-check-input ms-3" id="checkEmpo" v-model="form.usoSolEPPs" />
            </div>

            <div class="col-lg-1 col-md-4 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-house-check text-primary fs-6"> </i> USO DE UNIFORME
              </label>
              <input type="checkbox" class="form-check-input ms-3" id="checkEmpo" v-model="form.usoSolUniforme" />
            </div>

            <div class="col-lg-1 col-md-4 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-house-check text-primary fs-6"> </i> USO DE MOVIL COORPORATIVO
              </label>
              <input type="checkbox" class="form-check-input ms-3" id="checkEmpo"
                v-model="form.usoSolMovilCoporativo" />
            </div>

            <div class="col-lg-1 col-md-4 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-house-check text-primary fs-6"> </i> USO DE LAPTOP CORPORATIVA
              </label>
              <input type="checkbox" class="form-check-input ms-3" id="checkEmpo" v-model="form.usoSolLaptop" />
            </div>

            <div class="col-lg-1 col-md-4 col-6 mt-2">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-bandaid text-primary fs-6"></i>CARNET DE SANIDAD
              </label>
              <input type="checkbox" class="form-check-input ms-3" id="checkEmpo" v-model="form.IndSanidad" />
            </div>
            
          </div>
        </div>

        <div class="row g-2 ">
          <div class="col-12 col-md-6">
            <div class="border border-1 rounded-3 p-3 bg-light h-100">
              <div class="form-check mb-2">
                <input type="checkbox" class="form-check-input" id="checkEmpo" v-model="form.indEmpo" />
                <label for="checkEmpo" class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-heart-pulse text-danger fs-5"></i> EXAMEN MÉDICO PRE-OCUPACIONAL
                </label>
              </div>

              <!-- <div class="form-check">
                <input type="checkbox" class="form-check-input" id="checkCovid" v-model="form.indCovid" />
                <label for="checkCovid" class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-virus text-warning fs-5"></i> PRUEBA COVID
                </label>
              </div> -->
            </div>
          </div>
          <!-- Subida archivo -->
          <div class="col-12 col-md-6">
            <div class="border border-1 rounded-3 p-3 bg-light text-center h-100">
              <label for="fileInput" class="btn btn-outline-info mb-2 w-100">
                <i class="bi bi-upload fs-5 me-2"></i> Seleccionar archivo
                <input id="fileInput" type="file" ref="fileInput" style="display:none" @change="onFileSelected" />
              </label>
              <p class="small text-muted mb-0">
                (El tamaño del archivo no debe superar los 1024KB o 1MB)
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "SolimanologPostulanteSelect",

  data() {
    return {
      form: {
        IdPuesto: "",
        FecRegistro: "",
        fecSolicitada: "",
        idTrabajador: "",
        codMotivo: "",
        desMotivo: "",
        canPostulante: "",
        desExtra: "",
        idEmpresa: "",
        codCentro: "",
        codScc: "",
        codSscc: "",
        solUbigeo: "",
        codGerencia: "",
        adjunto: "",
        campana: false,
        // codTipContratacion: "",
        plazo: "",
        codTiempo: "",
        codCatOcupacional: "003",
        codTipContrato: "000",
        fecIniContrato: "",
        fecFinContrato: "",
        lugarTrabajo: "",
        horTrabajo: "",
        codModTrabajo: "",
        diasDescanso: "",
        codMoneda: "",
        sueldoMensual: "0",
        sueldoDiario: "0",
        monVariable: "0",
        monAlimentacion: "0",
        monMovilidad: "0",
        horaExtra: "0",
        monViatico: "0",
        monOtro: "0",
        codOpoPago: "002",
        codigoReniel: "000",
        indEmpo: false,
        indCovid: false,
        solDisViaje: false,
        solMovPropio: false,
        solAplicativo: false,
        usoSolAplicativo: false,
        usoSolEPPs: false,
        usoSolUniforme: false,
        usoSolMovilCoporativo: false,
        usoSolLaptop: false,
        IndSanidad: false,
      },

      cenCodigoCentro: "",

      seleccionarPuesto: "",
      codDepartamento: "",
      codProvincia: "",
      motivoSol: "",
      departamentoDes: "",
      provinciasDes: "",
      distritoDes: "",
      costos: "",
      subCostos: "",
      contrataciones: "",
      tiempoDes: "",
      categoria: "",
      contratoDes: "",
      parametro: "",
      gerenciaDes: "",
      subSubCentroCostos: "",
      modalidadTrab: "",
      monedas: "",
      pagoDes: "",
      reneeil: "",
      empresaDes: "",
      examen: "",
      prueba: "",
      puestos: [],
      motivoSolicitud: [],
      departamento: [],
      provincias: [],
      distrito: [],
      gerencia: [],
      contratacion: [],
      tiempos: [],
      ocupacional: [],
      contratos: [],
      modalidadTrabajo: [],
      monedita: [],
      oportunidad: [],
      filtradocontratos: [],
      reneeils: [],

      CentroCosto: [],
      SubCentroCosto: [],
      SubSubCentroCosto: [],
      selectedFile: "1",
      isdisabled: false,
      fd: null,

      dniTrabajador: null,
      fechaDeAhora: null,
      rqNumero: "",
      aparecerReniel: false,
      permisoVisualizador: null,
      idTrabajador: null,
      subRegiones: [],
      regiones: "",
      errorSueldoMensual: false,
      errorSueldoDiario: false
    };
  },

  async mounted() {
    this.idTrabajador = localStorage.getItem('idTrabajdor')
    this.permisoVisualizador = localStorage.getItem('idPerfil')
    let r = await this.axios.get("PuestoData/ListadoPuesto");
    this.puestos = r.data;

    let solicitud = await this.axios.get("ParametroData/Parametro/29");
    this.motivoSolicitud = solicitud.data;


    let subRegiones = await this.axios.get("ParametroData/Parametro/7892");
    this.subRegiones = subRegiones.data;
    console.log('hi', this.subRegiones)


    let depa = await this.axios.get("ParametroData/Parametro/350");
    this.departamento = depa.data;

    //let gerencia = await this.axios.get("ParametroData/Parametro/22");
    //this.gerencia = gerencia.data;

    let contrat = await this.axios.get("ParametroData/Parametro/49");
    this.contratacion = contrat.data;

    let tiempo = await this.axios.get("ParametroData/Parametro/7612");
    this.tiempos = tiempo.data;

    let categoria = await this.axios.get("ParametroData/Parametro/7495");

    this.ocupacional = categoria.data;

    // let contrato = await this.axios.get("ParametroData/Parametro/7406");
    //this.contratos = contrato.data;

    let modalidad = await this.axios.get("ParametroData/Parametro/52");
    this.modalidadTrabajo = modalidad.data;

    let moneda = await this.axios.get("ParametroData/Parametro/7317");
    this.monedita = moneda.data;

    let pago = await this.axios.get("ParametroData/Parametro/7616");
    this.oportunidad = pago.data;

    let reneeil = await this.axios.get("ParametroData/Parametro/7751");
    this.reneeils = reneeil.data;
    console.log(this.reneeil)

    this.form.idTrabajador = localStorage.getItem("idTrabajdor");
    this.dniTrabajador = localStorage.getItem("dniUsers");
    console.log(this.dniTrabajador);

    const tiempoTranscurrido = Date.now();
    const hoy = new Date(tiempoTranscurrido);
    this.fechaDeAhora = hoy.toISOString().slice(0, 10);
  },

  created() {
    this.getAttributes();
    this.cambiarEstadoNavbar();
  },

  computed: {
    ...mapGetters("users", [
      "Users",
      "NombresUsers",
      "DniEmpre",
      "Cargos",
      "Correo",
    ]),
  },

  methods: {
    ...mapActions("users", ["getAttributes"]),
    ...mapActions("solicitudesListado", ["getAttributs"]),

    cambiarEstadoNavbar() {
      //Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
    validarSueldoMensual() {
      const sueldo = Number(this.form.sueldoMensual);
      this.errorSueldoMensual = false;

      if (!sueldo) return;
      if (sueldo < 565 || sueldo > 50000) {
        this.errorSueldoMensual = true;
        this.form.sueldoMensual = 0;

        this.$toast?.error?.(
          "El sueldo mensual debe ser mayor o igual a S/ 565"
        );
      }


    },
    validarSueldoDiario() {
      const sueldo = Number(this.form.sueldoDiario);

      this.errorSueldoDiario = false;

      if (!sueldo) return;

      if (sueldo < 37.70 || sueldo > 400) {
        this.errorSueldoDiario = true;
        this.form.sueldoDiario = 0;

        this.$toast?.error?.(
          "El sueldo diario debe estar entre S/ 37.70 y S/ 400"
        );
      }
    },

    validaciongerencia() {
      console.log("Validando gerencia...");
      console.log("Valor actual de codCentro:", this.form.codCentro);

      this.axios.get("ParametroData/Parametro/22")
        .then((response) => {
          let gerencias = response.data;
          console.log("Gerencias obtenidas:", gerencias);

          let centrocosto = String(this.form.codCentro);
          console.log("Centro de costo convertido:", centrocosto);
          if (centrocosto === "01") {
            this.gerencia = gerencias.filter((item) =>
              ["25", "26"].includes(item.idParametro.toString())
            );
            console.log("Gerencia filtrada para centro 01:", this.gerencia);
          } else {
            // Aquí puedes decidir qué hacer: usar todos los datos o aplicar otro filtro
            this.gerencia = gerencias;
            console.log("Gerencia sin filtro:", this.gerencia);
          }
        })
        .catch((error) => {
          console.error("Error al obtener gerencias:", error);
        });
    },



    cargarContratos() {
      console.log("Cargando contratos...");
      console.log("Valor actual de this.form.idEmpresa:", this.form.idEmpresa);
      console.log("Valor actual de this.form.campana:", this.form.campana);
      console.log("Valor actual de centrocosto:", this.form.codCentro);
      console.log("Valor actual de subcentrocosto:", this.form.codScc);

      this.axios
        .get("ParametroData/Parametro/7406")
        .then((response) => {
          let contratos = response.data;
          console.log("Contratos obtenidos:", contratos);

          // Convertir a número si es un string
          let idEmpresa = Number(this.form.idEmpresa);
          let campana = Boolean(this.form.campana);
          let centrocosto = String(this.form.codCentro);
          let subcentrocosto = String(this.form.codScc);

          console.log("idEmpresa convertido a número:", idEmpresa);
          console.log("campana convertido a booleano:", campana);
          console.log("campana convertido a centro:", centrocosto);
          console.log("campana convertido a scc:", subcentrocosto);

          // Validación para Empresa 1
          if (idEmpresa === 1) {
            this.contratos = contratos.filter((contrato) =>
              ["7821", "7822", "7534"].includes(contrato.idParametro.toString())
            );
            console.log("Contratos filtrados para empresa 1:", this.contratos);
          }
          // Nueva validación para Empresa 2 y campana === true
          else if (idEmpresa === 2 && campana) {
            this.contratos = contratos.filter(
              (contrato) =>
                ["7823", "7534", "7533"].includes(
                  contrato.idParametro.toString()
                ) // Agrega los ID correspondientes
            );
            console.log(
              "Contratos filtrados para empresa 2 con campaña activa:",
              this.contratos
            );
          } else if (idEmpresa === 2 && centrocosto === "02") {
            this.contratos = contratos.filter(
              (contrato) =>
                ["7821", "7822", "7823"].includes(
                  contrato.idParametro.toString()
                ) // Agrega los ID correspondientes
            );
            console.log(
              "Contratos filtrados para empresa 2 con campaña activa:",
              this.contratos
            );
          } else if (
            idEmpresa === 2 &&
            centrocosto === "01" &&
            subcentrocosto === "0103"
          ) {
            this.contratos = contratos.filter(
              (contrato) =>
                ["7534", "7533"].includes(contrato.idParametro.toString()) // Agrega los ID correspondientes
            );
            console.log(
              "Contratos filtrados para empresa 2 con campaña activa:",
              this.contratos
            );
          } else if (idEmpresa === 3 && centrocosto === "02") {
            if (campana) {
              this.contratos = contratos.filter(
                (contrato) => ["7823"].includes(contrato.idParametro.toString()) // Solo si hay campaña
              );
              console.log(
                "Contratos filtrados para empresa 2 con campaña activa:",
                this.contratos
              );
            } else {
              this.contratos = contratos.filter(
                (contrato) =>
                  ["7534", "7532", "7533"].includes(
                    contrato.idParametro.toString()
                  ) // Todos los IDs sin campaña
              );
              console.log(
                "Contratos filtrados para empresa 2 sin campaña activa:",
                this.contratos
              );
            }
          } else if (idEmpresa === 4 && centrocosto === "02") {
            this.contratos = contratos.filter(
              (contrato) => ["7534"].includes(contrato.idParametro.toString()) // Agrega los ID correspondientes
            );
            console.log(
              "Contratos filtrados para empresa 2 con campaña activa:",
              this.contratos
            );
          }

          // Si no cumple ninguna condición, mostrar todos los contratos
          else {
            this.contratos = contratos;
            console.log("Contratos sin filtro:", this.contratos);
          }
        })
        .catch((error) => {
          console.error("Error al obtener contratos:", error);
        });
    },

    RegistrarSolcitud() {
      this.isdisabled = true;

      const tiempoTranscurrido = Date.now();
      const hoy = new Date(tiempoTranscurrido);

      this.form.FecRegistro = hoy.toISOString().slice(0, 10); // "2020-06-13T18:30:00.000Z"

      const fd = new FormData();

      fd.append("IdPuesto", this.form.IdPuesto);
      // fd.append("FecRegistros", this.form.FecRegistro);
      fd.append("FecSolicitadas", this.form.fecSolicitada);
      fd.append("IdTrabajador", this.form.idTrabajador);
      fd.append("CodMotivo", this.form.codMotivo);
      fd.append("DesMotivo", this.form.desMotivo);
      fd.append("CanPostulante", this.form.canPostulante);
      fd.append("DesExtra", this.form.desExtra);
      fd.append("IdEmpresa", this.form.idEmpresa);
      fd.append("CodCentro", this.form.codCentro);
      fd.append("CodScc", this.form.codScc);
      fd.append("CodSscc", this.form.codSscc);
      fd.append("CodGerencia", this.form.codGerencia);
      fd.append("SolUbigeo", this.form.solUbigeo);
      fd.append("Campana", this.form.campana);
      // fd.append("CodTipContratacion", this.form.codTipContratacion);
      fd.append("Plazo", this.form.plazo);
      fd.append("CodTiempo", this.form.codTiempo);
      fd.append("CodCatOcupacional", this.form.codCatOcupacional);
      fd.append("CodTipContrato", this.form.codTipContrato);
      fd.append("FecIniContratos", this.form.fecIniContrato);
      fd.append("FecFinContratos", this.form.fecFinContrato);
      fd.append("LugarTrabajo", this.form.lugarTrabajo);
      fd.append("HorTrabajo", this.form.horTrabajo);
      fd.append("CodModTrabajo", "001");
      fd.append("DiasDescanso", this.form.diasDescanso);
      fd.append("CodMoneda", this.form.codMoneda);
      fd.append("SueldoMensual", this.form.sueldoMensual);
      fd.append("SueldoDiario", this.form.sueldoDiario);
      fd.append("DiasDescanso", this.form.diasDescanso);
      fd.append("MonVariable", this.form.monVariable);
      fd.append("MonAlimentacion", this.form.monAlimentacion);
      fd.append("MonMovilidad", this.form.monMovilidad);
      fd.append("HoraExtra", this.form.horaExtra);
      fd.append("MonViatico", this.form.monViatico);
      fd.append("MonOtro", this.form.monOtro);
      fd.append("Reniel", this.form.codigoReniel);
      fd.append("solDisViaje", this.form.solDisViaje);
      fd.append("solMovPropio", this.form.solMovPropio);
      fd.append("solAplicativo", this.form.solAplicativo);
      fd.append("usoSolEPPs", this.form.usoSolEPPs);
      fd.append("usoSolUniforme", this.form.usoSolUniforme);
      fd.append("usoSolMovilCoporativo", this.form.usoSolMovilCoporativo);
      fd.append("usoSolLaptop", this.form.usoSolLaptop);

      fd.append("CodOpoPago", this.form.codOpoPago);
      fd.append("IndEmpo", this.form.indEmpo);
      fd.append("IndCovid", this.form.indCovid);
      fd.append("IndSanidad", this.form.IndSanidad);
      fd.append("ArchivoSol", this.selectedFile);
      fd.append("Adjunto", this.selectedFile);

      console.log(fd);

      this.axios
        .post("SolicitudData/Registrar", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((r) => {
          console.log(r.data);

           if (r.data != false) {
          //   this.isdisabled = true;
          //   setTimeout(() => {
          //     this.isdisabled = false;
          //   }, 2000);

            this.rqNumero = r.data.idSolicitud;
            console.log(r.data);
            this.MandarCorreo(r.data);
            this.MandarCorreoTI(r.data.idSolicitud);
            Swal.fire({
              title: `Se Registro Correctamente  RQ ${r.data.idSolicitud}`,
              width: 600,
              padding: "5em",
              color: "#716add",
              background: "#fff url(/images/trees.png)",
              backdrop: `
                  rgba(0,0,123,0.4)
                  url("/images/nyan-cat.gif")
                  left top
                  no-repeat
                `,
            }).then((result) => {
              // Se ejecutará cuando el usuario haga clic en el botón "Aceptar"
              if (result.isConfirmed) {
                // Recarga la página
                this.isdisabled = false;
                window.location.reload();
              }
            });  
             this.isdisabled = false;
          
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    MandarCorreo(correoTrabajador) {
      console.log(correoTrabajador);
      let correo = "seleccion@gruposolimano.com.pe";
      this.axios
        .post(
          `Values/MandarCorrreo?correoUsuario=${this.Correo}&correoUsuario2=${correoTrabajador.correoSel}&correoUsuario3=${correo}&idSolicitud=${this.rqNumero}&FecRegistro=${this.fechaDeAhora}&NombreEncargado=${this.NombresUsers}&SubCentro=${this.subCostos.cenNombre}&CantVacantes=${this.form.canPostulante}&idPuesto=${this.form.IdPuesto}`
        )
        .then((response) => {
          console.log(response.data);
        });
    },

    MandarCorreoTI(idSolicitud){
      console.log(idSolicitud  ,this.form.usoSolMovilCoporativo ,this.form.usoSolLaptop, this.NombresUsers)
      
            // Los valores los tomamos de tu objeto data()
        const nombre = this.NombresUsers;
        const rq = idSolicitud;
        const tieneLaptop = this.form.usoSolLaptop ? 'SI' : 'NO';   // true o false
        const tieneCelular = this.form.usoSolMovilCoporativo ? 'SI' : 'NO'; // true o false

        if(this.form.usoSolLaptop || this.form.usoSolMovilCoporativo){
          this.axios
          .post(
            `SolicitudData/CorreoTecnologia?nombrePersona=${nombre}&RqNumero=${rq}&celular=${tieneCelular}&laptop=${tieneLaptop}&idPuesto=${this.form.IdPuesto}`
          )
          .then((response) => {
            if (response.data.success) {
            console.log("Respuesta del servidor:", response.data);
            }
          })
          .catch((error) => {
            console.error("Error al enviar:", error);
          });
        } else {
          console.log("No se requiere enviar correo a TI.");
        }
        

    },

    Puesto(event) {
      this.form.IdPuesto = event.target.value;
    },

    Motivo(event) {
      this.form.codMotivo = event.target.value;
    },

    Empresa(event) {
      this.costos = "";
      this.subCostos = "";
      this.form.idEmpresa = event.target.value;
      console.log("esta es la empresa" + event.target.value);

      // this.aparecerReniel = (event.target.value == 4) ? true : false;

      if (event.target.value == 4) {
        this.aparecerReniel = true
      } else {
        this.aparecerReniel = false
        this.codigoReniel = '000'
      }


      this.axios
        .get(
          `Ccosto/CentroxTrabajador?idEmpresa=${this.form.idEmpresa}&dniUser=${this.dniTrabajador}`
        )
        .then((r) => {
          console.log("mi tia", r.data)
          this.CentroCosto = r.data;
          console.log('aaga', this.CentroCosto.length)
          if (this.CentroCosto.length == 1) {
            this.cenCodigoCentro = this.CentroCosto[0].cenCodigo;
          }
          // this.cenCodigoCentro = this.CentroCosto[0].cenCodigo

          this.CostosEvent()
        });
    },

    CostosEvent() {
      // event
      // console.log(event.target.value);
      //  this.cenCodigoCentro = event.target.value;
      console.log("llego")
      this.axios
        .get(
          `SubCentro/SubCxTrabajador?codCenCosto=${this.cenCodigoCentro}&dniUser=${this.dniTrabajador}&idEmpresa=${this.form.idEmpresa}`
        )
        .then((r) => {
          console.log("ss", this.SubCentroCosto)
          this.SubCentroCosto = r.data;
        });
    },

    SubCostros() {
      console.log(this.subCostos.cenSubCentro);

      this.axios
        .get(
          `SubSubCentro/SScxTrabajador?idEmpresa=${this.form.idEmpresa}&dniUser=${this.dniTrabajador}&codCentro=${this.cenCodigoCentro}&codSubCentro=${this.subCostos.cenSubCentro}`
        )
        .then((r) => {
          this.SubSubCentroCosto = r.data;
          console.log(r.data);
        });
    },

    SubSubCentroCostoId(event) {
      console.log(event.target.value);

      this.axios
        .get(`SubSubCentro/ObtenerSububCentro/${event.target.value}`)
        .then((r) => {
          this.form.codCentro = r.data[0].cenCodigo;
          this.form.codScc = r.data[0].cenSubCodigo;
          this.form.codSscc = r.data[0].cenSubSubCodigo;
        });
    },

    Depa(event) {

      console.log(event.target.value)

      this.axios
        .get(`ParametroData/ParametroDepxProv/${event.target.value}`)
        .then((r) => {
          this.codDepartamento = r.data[0].parCorrelativo;
        });

      this.distritoDes = "";
      this.provinciasDes = "";
      this.axios
        .get(`ParametroData/Parametro/${event.target.value}`)
        .then((r) => {
          this.provincias = r.data;
        });
    },

    Province(event) {
      this.regiones = event.target.value
      console.log(event.target.value)
      this.axios
        .get(`ParametroData/ParametroDepxProv/${event.target.value}`)
        .then((r) => {
          this.codProvincia = r.data[0].parCorrelativo;
        });

      this.distritoDes = "";
      this.axios.get(`DistritoData/Listar/${event.target.value}`).then((r) => {
        this.distrito = r.data;
      });
    },

    DistritoDes(event) {
      this.form.solUbigeo = event.target.value;
      console.log(this.form.solUbigeo)
      //
    },
    onFileSelected(event) {
      this.selectedFile = event.target.files[0];
      console.log(this.selectedFile.name);
    },

    Gerencia(event) {
      this.form.codGerencia = event.target.value;
    },

    ContratoTipo(event) {
      this.form.codTipContratacion = event.target.value;
    },

    Tiempo(event) {
      this.form.codTiempo = event.target.value;
    },

    CategoriaOcupa(event) {
      this.form.codCatOcupacional = event.target.value;
    },

    TipContratato(event) {
      this.form.codTipContrato = event.target.value;
    },

    ModalidadTrabajo(event) {
      this.form.codModTrabajo = event.target.value;
    },
    Moneda(event) {
      this.form.codMoneda = event.target.value;
    },
    OportunidadPago(event) {
      this.form.codOpoPago = event.target.value;
    },
    ServicioComplemetarios(event) {
      this.form.codigoReniel = event.target.value;
      console.log(event.target.value)
    },
  },
};
</script>

<style scoped>
input[type="text"],
input[type="textArea"],
textArea {
  text-transform: uppercase;
}

.selector {
  width: 500px;
}

#modal-center5 .modal-dialog {
  min-height: 300px;
  /* Ajusta el valor según tus necesidades */
}

/*----*/

.reducirTamaño {
  font-size: 0.65rem;
}

.reducirTamañoLabel {
  font-size: 0.9rem;
}

.tipoLetra {
  font-family: "Poppins", sans-serif;
}

.bg-solimano {
  background: #1565c0;
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.boton-estiloPag {
  border: 1px solid rgb(199, 199, 199);
  background-color: white;
  color: rgb(32, 32, 32);
  padding: 0.6rem 1rem;
  border-radius: 0;
}

.boton-estiloCuadrado {
  padding: 0.2rem 0.55rem;
  cursor: pointer;
  /* Cambia el cursor a una mano */
}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.tabla-estiloCompreso {
  padding: 0.3rem 0.55rem;
}

.label-resaltado {
  font-weight: 700;
  font-size: 0.65rem;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}
</style>
